import { createIcon } from '../utils';

export const TransmissionsIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1 1H19M1 7H19M1 13H19"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'TransmissionsIcon',
    defaultSize: 20,
    defaultVariant: 'primary',
  },
);
